export default __webpack_public_path__ + "static/media/revit_icon.568979f7.png";